import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import EnforcedSetup from 'components/settings/profile/twoFactorAuthentication/EnforcedSetup';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <EnforcedSetup {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    afterSetupPath: PropTypes.string.isRequired,
    canUserSkip: PropTypes.bool.isRequired,
  }).isRequired,
};
